import { render, staticRenderFns } from "./CotStruttureListComponent.vue?vue&type=template&id=69b978db"
import script from "./CotStruttureListComponent.vue?vue&type=script&lang=js"
export * from "./CotStruttureListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports